import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ModMenu from './ModTools.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
document.title = "TuneTracker"
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/mod/' element={<ModMenu />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
